<template>
  <div class="master-table-type">

    <div class="m-bottom-8">
      <el-row>
        <el-col :span="12">
          <label class="label lb2">サイネージページ</label>
        </el-col>
        <el-col :span="12">
          <div class="st-page-size">
            <label class="label lb2 lable-right-16">表示件数</label>
            <el-select
              v-model="page.pageSize">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-table id="search-result" width="100%" :data="tableData.pages" :fit="true">

      <!--  ページ名 -->
      <el-table-column
        class-name="col-align-top col-6"
        prop="cmsTitle"
        label="ページ名"
      />

      <!--  サブタイトル -->
      <el-table-column
        class-name="col-align-top col-6"
        prop="cmsSubTitle"
        label="サブタイトル"
      />
      <!--  表示形式  -->
      <el-table-column class-name="col-4" label="表示形式">
        <template v-slot="scope">
          <p :style="{ color: (isActualPage(scope.row) && !scope.row.diplayMethod) ? '#B8B8B4' : 'inherit' }">
            {{isActualPage(scope.row) ? (scope.row.diplayMethod == '01' ? 'マップ' : scope.row.diplayMethod == '02' ? 'リスト（画像あり）' : scope.row.diplayMethod == '03' ? 'リスト（画像なし）': 'カレンダー') : '-'}}
          </p>
        </template>
      </el-table-column>

      <!--   その他操作列   -->
      <el-table-column class-name="col-2">
        <template v-slot="scope">
          <div v-auth="{ auth: '060408'}" class="detail-button with-100">
            <!--  照会バータン  -->
            <sp-smart-button
              class="detailed-but with-100"
              @click="clickPageDetail(scope.row)"
              v-show="isActualPage(scope.row)"
            >
              {{$t('button.common.detail')}}
            </sp-smart-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column class-name="col-2" class="text-right">
        <template v-slot="scope">
          <div v-auth="{ auth: '060409'}" class="text-center">
            <el-popconfirm
              popper-class="iot-pop-confirm"
              :title="$t('message.system.owner.deleteConfirm')"
              :confirmButtonText="$t('button.common.ok')"
              :cancelButtonText="$t('button.common.cancel')"
              class="btn-operate"
              @onConfirm="handleDeleteAction(scope.row)">
              <sp-smart-button
                slot="reference"
                class="button-width-100 margin-left-1"
                v-show="!scope.row.deleteFlag && isActualPage(scope.row)"
              >
                {{$t("button.common.data.delete")}}
              </sp-smart-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="result.body.length > 0"
      class="pagination"
      :totalCount="result.totalCount"
      :totalPage="result.totalPage"
      :pageSize="page.pageSize"
      :pageNumber="page.pageNumber"
      @on-paging="handlePagingAction" />
  </div>
</template>

<script>
const EVENT_DETAIL = "on-detail";
const EVENT_DELETE = "on-delete";
const EVENT_PAGING = "on-paging";
import SpSmartButton from "@/components/common/sp-smart-button";
import Pagination from "@/components/common/pagination/Pagination";

export default {
  name: "VisualPageManagementSearchResult",
  components: { SpSmartButton, Pagination },
  data() {
    return {
      page: {
        pageSize: 10,
        pageNumber: 1
      },
      options: [
        {
          label: "10件",
          value: 10,
        },
        {
          label: "20件",
          value: 20,
        },
        {
          label: "50件",
          value: 50,
        },
      ],
      tableLoadingAnim: null
    };
  },
  props: {
    result: Object,
    showLoading: Boolean
  },
  created() {
    this.page.pageSize = this.result['pageSize'];
    this.page.pageNumber = this.result['pageNumber'];
  },
  watch: {
    page: {
      handler(val) {
        if(val != 0){
          this.$emit(EVENT_PAGING, val);
        }
      },
      deep: true,
    },
    result: {
      handler(val) {
        this.page.pageSize = val['pageSize'];
        this.page.pageNumber = val['pageNumber'];
      },
      deep: true,
    },
    showLoading(val) {
      if (val) {
        this.showTableLoadingAnim();
      } else {
        this.hideTableLoadingAnim();
      }
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },

    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        })
      }
    },

    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close()
        this.tableLoadingAnim = null
      }
    },

    //編集バータン
    clickPageDetail(row) {
      this.$emit(EVENT_DETAIL, row.cmsId);
    },

    //削除バータン
    handleDeleteAction(row) {
      this.$emit(EVENT_DELETE, row.cmsId);
    },

    handlePagingAction(pagination) {
      this.page.pageNumber = pagination.pageNumber
    },

    isActualPage(page) {
      return !page.cmsId.startsWith('dummy');
    },
  },
  computed: {
    tableData() {

      // pages 后台默认按照 area 级别的排序好了，这里不需要再进行排序。
      let pages = this.result.body;
      let buildings = [];
      let sortable = {};

      for (const page of pages) {
        let { ownerId, buildingId, areaId, cmsId } = page;

        let building = buildings.find((building) => building.buildingId === buildingId);
        if (building === undefined) {
          building = {
            buildingId,
            buildingExId: page.buildingExId,
            buildingName: page.buildingName,
            ownerId,
            ownerName: page.ownerName,
            ownerExId: page.ownerExId,
            areas: []
          };
          buildings.push(building);
        }

        let area = building.areas.find((area) => area.areaId === areaId);
        if (area === undefined) {
          area = {
            areaId,
            areaName: page.areaName,
            floorId: page.floorId,
            floorName: page.floorName,
            pages: []
          }
          building.areas.push(area);
        }

        sortable[cmsId] = {
          canUp: area.pages.length > 0,
          canDown: true
        };

        area.pages.push({
          cmsId,
          cmsTitle: page.cmsTitle,
          diplayMethod: page.diplayMethod,
          deleteFlag: page.deleteFlag
        });

      }

      for (let building of buildings) {
        for (let area of building.areas) {
          const { pages } = area;
          for (let i = 0, maxIndex = pages.length - 1; i < pages.length; i++) {
            const { cmsId } = pages[i];
            sortable[cmsId] = {
              canUp: i > 0,
              canDown: i < maxIndex
            };
          }
        }
      }

      // buildings
      let buildingSpans = [];
      let areaSpans = [];

      for (let building of buildings) {
        let count = 0;
        for (let area of building.areas) {
          const span = area.pages.length
          if (areaSpans.length === 0) {
            areaSpans.push([0, span]);
          } else {
            const lastSpan = areaSpans[areaSpans.length - 1];
            areaSpans.push([lastSpan[0] + lastSpan[1], span]);
          }
          count += area.pages.length
        }
        if (buildingSpans.length === 0) {
          buildingSpans.push([0, count]);
        } else {
          const lastSpan = buildingSpans[buildingSpans.length - 1];
          buildingSpans.push([lastSpan[0] + lastSpan[1], count])
        }
      }

      return {
        building: buildingSpans,
        area: areaSpans,
        sortable,
        pages: this.result.body
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .col-align-top {
  vertical-align: top;
}
::v-deep .col-align-top .cell {
  margin-top: 0;
  min-height: 73px;
  display: flex;
  align-items: center;
}
::v-deep .detail-button {
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}
::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}
.pagination {
  margin-top: 30px;
}
.m-bottom-8 {
  margin-bottom: 8px !important;
}
</style>
